// extracted by mini-css-extract-plugin
export var columnList = "_fs-0";